
export enum sortTypes {
    asc = 'asc',
    desc = 'desc'
}


export type sortBy = Array<string>;
export type sortType = sortTypes.asc | sortTypes.desc | null;